
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getOrganization",
      resolverType: "query",
      routePath: "/getOrganization",
      httpMethod: "POST",
    });
  